import api from "../api/axios";
import { getAnonymousId } from "./cookieConsent";

export const linkCookieConsentToCustomer = async () => {
  try {
    const anonymous_id = getAnonymousId();

    await api.post(`/cookieConsentRoutes/cookie_consent/link`, {
      anonymous_id,
    });
  } catch (error) {
    console.warn("Cookie consent link failed:", error);
  }
};